import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';
import { IAppState } from 'src/store';
import { View } from '../common';

const Footer: React.FC<Props> = () => {
  return <View className="cmp-footer">Copyright © 2021 Ralph Rosenberg Court Reporter</View>;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
